<fieldset class="dropdown-with-search" appClickOutside (clickOutside)="clickedOutside()">
  <div class="position-relative">
    <header
      (click)="setActive()"
      [class.error]="error"
      [class.active]="isActive">
      <input type="text"
             class="form-control selected-value-input"
             placeholder="Select one"
             name="search-input"
             [value]="name"
             [required]="isRequired"
             [class.no-bottom-border-radius]="isActive"
             [class.value-not-selected-border]="isActive && !selectedName"
             [class.value-selected-border]="selectedName && !error"
             [ngClass]="{'ng-invalid ng-touched' : error}"
             readonly
             [attr.yp-e2e-id]="'dropdown-with-search-select-input'" />
    </header>
    <article *ngIf="isActive" [class.border-top-0]="isActive">
      <input type="search"
             class="form-control form-control-search search-input"
             placeholder="Search here..."
             [(ngModel)]="search"
             [attr.yp-e2e-id]="'dropdown-with-search-input'" />
      <ul class="options" *ngIf="selectOptions.length">
        <li *ngFor="let option of selectOptions | searchFilter: search : 'label'"
            (click)="selectOption(option.value)"
            [class.active]="selectedValue === option.value"
            [attr.yp-e2e-id]="'dropdown-with-search-option-'+option.value">
          {{ option.label }}
        </li>
      </ul>
      <div *ngIf="!selectOptions.length" class="no-results">No results</div>
    </article>
  </div>
</fieldset>
